import OrganizationsList from "../OrganizationsList";
import ProfileHeader from "../ProfileHeader";

export default function Curator() {
	return (
    <div className='profile_content'>
				<div className='profile_block_cont'>
					<ProfileHeader/>
					<OrganizationsList/>
				</div>
			</div>
	)
}